import React, { useEffect, useState, useRef } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import { displayErrorToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { addDocumentRequest, addDocumentRequestStatus } from '../../../redux/document/document.action'
import { employeeListRequest } from '../../../redux/employee/employee.action'
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Modal from 'react-bootstrap/Modal';

const AddDocument = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { addDocumentSuccess, addDocumentError, addDocumentReqStatus } = useSelector(state => state.document)
    const { employeeListSuccess, employeeListError } = useSelector(state => state.employee)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [showSuccessModal, setShowSuccessModal] = useState(false)
    const [isAssignEmployeeCheck, setIsAssignEmployeeCheck] = useState(false)
    const [selectedEmployee, setSelectedEmployee] = useState(null)
    const [assignEmployeeModal, setShowAssignEmployeeModal] = useState(false)
    const [isDownloadable, setIsDownloadable] = useState(false)
    const [searchQuery, setSearchQuery] = useState('')
    const [name, setName] = useState('')
    const [imagePath, setImagePath] = useState(null)
    const [imageName, setImageName] = useState('')
    const [imagePreview, setImagePreview] = useState(null);
    const inputFile = useRef(null)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_DOCUMENT, true)
            fetchBusinessList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.ADD_DOCUMENT) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_DOCUMENT, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(employeeListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(employeeListError)) {
            setLoading(false)
        }
    }, [employeeListSuccess, employeeListError])

    useEffect(() => {
        if (addDocumentReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            setShowSuccessModal(true)
        } else if (addDocumentReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(addDocumentError.message)
        }
        if (addDocumentReqStatus?.length) {
            dispatch(addDocumentRequestStatus(''))
        }
    }, [addDocumentSuccess, addDocumentError, addDocumentReqStatus])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    const fetchEmployeeList = () => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user)) {
            if (!isEmpty(selectedBusiness)) {
                data.businessId = selectedBusiness.businessId
                // data.locationId = selectedLocation.locationId
            }
        } else if (isLoggedInUserEmployee(user)) {
            data.businessId = employeeSelectedBusiness
        }
        if (!isEmpty(searchQuery)) {
            data.searchQuery = searchQuery
        }
        dispatch(employeeListRequest(data))
    }

    const handleSelectEmployeeClick = () => {
        setSelectedEmployee(null)
        setSearchQuery('')
        setShowAssignEmployeeModal(true)
        fetchEmployeeList()
    }

    const handleGoBack = () => {
        navigate(-1, { replace: true });
    };

    const clearFields = () => {
        setName('')
        setIsAssignEmployeeCheck(false)
        setShowSuccessModal(false)
        setSearchQuery('')
        setImagePath(null)
        setImageName('')
        setIsDownloadable(false)
        if (inputFile.current) {
            inputFile.current.value = null
        }
    }

    const handleNewDocumentAddClick = () => {
        setShowSuccessModal(false)
        clearFields()
    }

    const handleImageChange = event => {
        if (!isEmpty(event.target.files)) {
            setImagePath(event.target.files[0])
            setImageName(event.target.files[0].name)
        } else {
            setImagePath(null)
            setImageName('')
        }
    }

    const handleSubmitClick = () => {
        if (isEmpty(name)) {
            displayErrorToast('Document name cannot be blank')
        } else if (isLoggedInUserBusiness(user) && isEmpty(selectedBusiness)) {
            displayErrorToast('Business not selected')
        } else if (isLoggedInUserBusiness(user) && isEmpty(selectedLocation)) {
            displayErrorToast('Business location not selected')
        } else if (isAssignEmployeeCheck === true && isEmpty(selectedEmployee)) {
            displayErrorToast('Employee to assign document is not selected')
        } else if (isEmpty(imagePath) && isEmpty(imageName)) {
            displayErrorToast('Document not selected')
        } else {
            setLoading(true)
            const fd = new FormData()
            fd.append('name', name)
            fd.append('businessId', isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness)
            fd.append('locationId', isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation)
            fd.append('assignorId', isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId)
            fd.append('assignorUserType', user.data.userDetails.userType)
            fd.append('isDownloadable', isDownloadable)

            if (isAssignEmployeeCheck === true) {
                fd.append('assigneeId', selectedEmployee.employeeId)
                fd.append('assigneeUserType', selectedEmployee.userType)
            }
            if (!isNull(imagePath) && !isEmpty(imageName))
                fd.append('document', imagePath, imageName)
            dispatch(addDocumentRequest(fd))
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='New Document' />
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to add new document' />
                    <CommonInputFloatFull
                        type='text'
                        id='name'
                        onChange={e => setName(e.target.value)}
                        placeholder='Document Name'
                        value={name}
                    />
                    <FormFieldLabel className='up-bold-label' label='Business Details' />
                    {isLoggedInUserBusiness(user) === true && <div>
                        <FormFieldLabel label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>}
                    {isLoggedInUserBusiness(user) === true && !isEmpty(selectedBusiness) && <div>
                        <FormFieldLabel label='Select Business Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                    <div className="ae-cb-row-container">
                        <div className="ae-phone-input-container">
                            <CommonCheckbox id='assignManager'
                                label='Assign Employee'
                                onChange={e => setIsAssignEmployeeCheck(e.target.checked)}
                                value={isAssignEmployeeCheck}
                            />
                        </div>
                        {isAssignEmployeeCheck === true && <div className="ae-select-btn-container" onClick={() => { handleSelectEmployeeClick() }}>Click To Select</div>}
                    </div>
                    {isAssignEmployeeCheck === true && !isEmpty(selectedEmployee) && <FormFieldLabel label='Selected Employee' />}
                    {isAssignEmployeeCheck === true && !isEmpty(selectedEmployee) && <div className="ae-emp-list-item-container">
                        <div className="ae-emp-list-item-content-container">
                            <div className="ae-emp-name-label">{selectedEmployee.firstName} {selectedEmployee.lastName}</div>
                            <div className="ae-emp-code-label">{selectedEmployee.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? selectedEmployee.employeeCode : ''}</div>
                            <div className="ae-emp-name-label">{selectedEmployee.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? selectedEmployee.role : ''}</div>
                        </div>
                    </div>}
                    <CommonCheckbox id='downloadable'
                        label='Is Downloadable'
                        onChange={e => setIsDownloadable(e.target.checked)}
                        value={isDownloadable}
                    />
                    <FormFieldLabel label='Select Document' />
                    <div className="input-group">
                        <input type="file" ref={inputFile} className="form-control" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload Document" onChange={handleImageChange} />
                    </div>
                    <ButtonRow>
                        <CommonButton label='Submit' onClick={() => { handleSubmitClick() }} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowSuccessModal(false) }}
                show={showSuccessModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-img-container">
                            <img src={require('../../../assets/success_tick.png')} className="img" />
                        </div>
                        <div className="at-success-text">{addDocumentSuccess?.data?.message}</div>
                        <div className="at-next-task-text">Do you want to add another document?</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => { handleGoBack() }}>NO</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleNewDocumentAddClick() }}>YES</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowAssignEmployeeModal(false) }}
                show={assignEmployeeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Select Employee
                </Modal.Header>
                <Modal.Body>
                    <div className="ol-search-parent-container">
                        <div className="ol-search-row-parent-container">
                            <div className="ol-search-input-container">
                                <input type="text" className="ol-input-no-border" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search Employee" />
                            </div>
                            <div className="ol-search-icon-container" onClick={() => { fetchEmployeeList() }}>
                                <img src={require('../../../assets/ic_search_orange.png')} className="img" />
                            </div>
                        </div>
                    </div>
                    {!isEmpty(employeeListSuccess) && <div className="ae-emp-list-container">
                        {!isEmpty(employeeListSuccess.data) && employeeListSuccess.data.map(e => (<div className="ae-emp-list-item-container">
                            <div className="ae-emp-list-item-content-container">
                                <div className="ae-emp-name-label">{e.firstName} {e.lastName}</div>
                                <div className="ae-emp-code-label">{e.employeeCode}</div>
                                <div className="ae-emp-name-label">{e.role}</div>
                            </div>
                            <div className="ae-row-btn-container" onClick={() => {
                                setSelectedEmployee(e)
                                setShowAssignEmployeeModal(false)
                            }}>Select</div>
                        </div>))}
                    </div>}
                    <div className="td-or-label">OR</div>
                    <div className="td-or-btn-container">
                        <CommonButton label='Assign Self' onClick={() => {
                            setSelectedEmployee(user.data.userDetails)
                            setShowAssignEmployeeModal(false)
                        }} />
                    </div>
                    {!isEmpty(employeeListError) && <div className="content-error">{employeeListError.message}</div>}
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AddDocument